import React from 'react';

interface Logo {
  src: string;
  alt: string;
  url?: string;
}

interface LogoTickerProps {
  logos?: Logo[];
}

// Default allies logos from public/images/allies
const defaultAlliesLogos: Logo[] = [
  { src: '/images/allies/qualfon_logo.png', alt: 'Qualfon' },
  { src: '/images/allies/nacionalMonte_logo.png', alt: 'Nacional Monte de Piedad' },
  { src: '/images/allies/modatelas_logo.png', alt: 'Modatelas' },
  { src: '/images/allies/mggl_logo.png', alt: 'MGGL' },
  { src: '/images/allies/mattel_logo.png', alt: 'Mattel' },
  { src: '/images/allies/IHO_logo.png', alt: 'IHO' },
  { src: '/images/allies/gobMex_logo.png', alt: 'Gobierno de México' },
];

const LogoTicker: React.FC<LogoTickerProps> = ({ logos }) => {
  const displayLogos = logos && logos.length > 0 ? logos : defaultAlliesLogos;
  return (
    <div className="w-screen py-20 overflow-hidden">
      <h2 className="text-center headline-large mb-16">Aliados y Donantes</h2>
      <div className="relative w-screen overflow-hidden">
        <div className="absolute left-0 w-[20%] h-full bg-gradient-to-r from-[#F7F7F7] to-transparent z-10"></div>
        <div className="absolute right-0 w-[20%] h-full bg-gradient-to-l from-[#F7F7F7] to-transparent z-10"></div>
        <div className="flex animate-scroll">
          {/* First set of logos */}
          {displayLogos.map((logo, index) => (
            <div key={`logo-1-${index}`} className="flex-shrink-0 mx-16 flex items-center justify-center">
              {logo.url ? (
                <a href={logo.url} target="_blank" rel="noopener noreferrer">
                  <img src={logo.src} alt={logo.alt} className="max-h-[120px] max-w-[120px] object-contain" />
                </a>
              ) : (
                <img src={logo.src} alt={logo.alt} className="max-h-[120px] max-w-[120px] object-contain" />
              )}
            </div>
          ))}
          {/* Duplicate logos for seamless scrolling */}
          {displayLogos.map((logo, index) => (
            <div key={`logo-2-${index}`} className="flex-shrink-0 mx-16 flex items-center justify-center">
              {logo.url ? (
                <a href={logo.url} target="_blank" rel="noopener noreferrer">
                  <img src={logo.src} alt={logo.alt} className="max-h-[120px] max-w-[120px] object-contain" />
                </a>
              ) : (
                <img src={logo.src} alt={logo.alt} className="max-h-[120px] max-w-[120px] object-contain" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LogoTicker; 